import "vite/modulepreload-polyfill";
import { createRoot } from "react-dom/client";
import { Suspense, lazy } from "react";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { jqHomeFeaturedSecondaryCard } from "./utils/jqHomeFeaturedSecondaryCard";
import { collectionPageGridline } from "./utils/collectionPageGridline";
import { jqPauseRedirect } from "./utils/jqPauseRedirect";
import { jqAccordionDropdown } from "./utils/jqAccordionDropdown";
import { footerInit } from "./utils/footer";
import { forms } from "./components/forms/forms";
import { scrollProgress } from "./utils/scrollProgress";
import { inPageTabsLoad } from "./utils/inPageTabs";
import { headerVideoTextAnimation } from "./utils/headerVideoAnimation";
import { utilityContainerCardAlignment } from "utils/utilityContainerCardsAlignment";
import toggleStickyScrollSection from "./utils/toggleStickyScrollSection";
import triggerDDiffAnimations from "utils/ddiff-animations/triggerDDiffAnimations";
import triggerIndividualSiteAnimations from "utils/individual-site-animations/triggerIndividualSiteAnimations";
import handleLittleITooltips from "components/little-i-tooltip/handleLittleITooltips";
import positionMicroCapLabels from "components/ddiff-animated-exhibit/positionMicroCapLabels";
import { drawMicroCapClipPath } from "components/ddiff-animated-exhibit/drawMicroCapClipPath";
import { handleAnchorRowLinks } from "components/anchor-link-row/anchorLinkFunctionality";
import { ddxFaa } from "utils/ddxFaa";
import { initImageInDonutHeight } from "components/animated-donut/initImageInDonutHeight";

if (process.env.NODE_ENV === "development") {
	const LocalApp = lazy(() => import("./LocalApp"));
	const root = createRoot(document.getElementById("content-react-root"));
	root.render(
		<BrowserRouter>
			<Suspense fallback={<div />}>
				<LocalApp />
			</Suspense>
		</BrowserRouter>
	);
	window.addEventListener("load", function () {
		window._WINDOW_WIDTH_IOS = window.innerWidth;
		window._WINDOW_HEIGHT_IOS = window.innerHeight;
		const littleITooltips = document.querySelectorAll(".little-i");
		if (littleITooltips.length) {
			handleLittleITooltips(littleITooltips);
		}

		const anchorLinks = document.querySelectorAll(".anchor-link");
		if (anchorLinks.length) {
			handleAnchorRowLinks(anchorLinks);
		}

		const microcapChart = document.querySelectorAll(".ddiff-micro-cap-chart-exhibit-floor");
		if (microcapChart.length) {
			drawMicroCapClipPath(microcapChart);
		}

		const animatedDonutImageCards = document.querySelectorAll(".animated-donut-image");
		if (animatedDonutImageCards.length) {
			initImageInDonutHeight();
		}

		triggerIndividualSiteAnimations();
		triggerDDiffAnimations();
		toggleStickyScrollSection();
		jqHomeFeaturedSecondaryCard();
		collectionPageGridline();
		jqPauseRedirect(window.pausePageData);
		jqAccordionDropdown();
		footerInit();
		inPageTabsLoad();
		headerVideoTextAnimation();
		utilityContainerCardAlignment();
	});
} else {
	//render react components by container
	document.querySelectorAll(".react-root").forEach((el) => {
		const view = el.dataset.view;
		const dataset = el.dataset;
		const root = createRoot(el);
		root.render(
			<BrowserRouter>
				<App view={view} dataset={dataset} />
			</BrowserRouter>
		);
	});

	window.addEventListener("load", function () {
		window._WINDOW_WIDTH_IOS = window.innerWidth;
		window._WINDOW_HEIGHT_IOS = window.innerHeight;
		if (document.querySelector(".scf-form")) {
			forms();
		}
		if (document.getElementById("scroll-progress-bar")) {
			scrollProgress();
		}

		const littleITooltips = document.querySelectorAll(".little-i");
		if (littleITooltips.length) {
			handleLittleITooltips(littleITooltips);
		}

		const anchorLinks = document.querySelectorAll(".anchor-link");
		if (anchorLinks.length) {
			handleAnchorRowLinks(anchorLinks);
		}

		const microcapChart = document.querySelectorAll(".ddiff-micro-cap-chart-exhibit-floor");
		if (microcapChart.length) {
			drawMicroCapClipPath(microcapChart);
			positionMicroCapLabels();
		}

		const animatedDonutImageCards = document.querySelectorAll(".animated-donut-image");
		if (animatedDonutImageCards.length) {
			initImageInDonutHeight();
		}

		triggerIndividualSiteAnimations();
		triggerDDiffAnimations();
		toggleStickyScrollSection();
		jqHomeFeaturedSecondaryCard();
		collectionPageGridline();
		jqPauseRedirect(window.pausePageData);
		jqAccordionDropdown();
		footerInit();
		inPageTabsLoad();
		headerVideoTextAnimation();
		ddxFaa();
	});
}
